import Clients from '@src/routes/Clients';
import i18next from 'i18next';

import { CLIENTS_MODULE_PATHS } from '@src/commons/features/utils/modulePaths';

export const CLIENTS = {
  getText: () => i18next.t('GENERAL.CLIENTS'),
  Component: Clients,
  path: CLIENTS_MODULE_PATHS.CLIENTS,
  icon: '/icons/store-black-small.svg',
  isFullScreen: false
};
